import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText } from '@mui/material';
import { serviceTypeDetails } from '../../enum/serviceType';

function ServiceTypeFilter({ selectedTypes, setSelectedTypes }) {
    const handleChange = (event) => {
        const value = event.target.value;
        setSelectedTypes(typeof value === 'string' ? value.split(',') : value);
    };

    return (
        <FormControl variant="outlined" size="small" sx={{ minWidth: 150, ml: 5, backgroundColor: 'white' }}>
            <InputLabel id="service-type-label" sx={{ color: 'black', fontWeight: 'bold' }}>
                Service Types
            </InputLabel>
            <Select
                labelId="service-type-label"
                multiple
                value={selectedTypes}
                onChange={handleChange}
                label="Service Types"
                renderValue={(selected) => selected.join(', ')}
            >
                {serviceTypeDetails.map((service) => (
                    <MenuItem key={service.type} value={service.type}>
                        <Checkbox checked={selectedTypes.includes(service.type)} />
                        <ListItemText
                            primary={service.type}
                            secondary={service.fullName}
                        />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default ServiceTypeFilter;
